export default "__VITE_ASSET__983e7b00__"